export default {
    namespaced: true,
    state: {
        my_name: '云飞阁',
        term_softs: [
            '云飞阁',
        ],
        fen_softs: [
        ]
    }
}